export default __webpack_public_path__ + "static/media/playImage.dab9195c.svg";